<template>
  <v-col cols="6" class="g-file-upload d-flex flex-column px-4">
    <v-row class="d-flex flex-row align-center">
      <input
        type="file"
        :accept="accepts"
        required
        class="g-input-upload"
        ref="input"
        @change="setFile"
      />

      <v-text-field
        label="Nome do Arquivo"
        accept
        :loading="loading"
        v-model="nomeArquivo"
        :hint="`Formatos aceitos: ${accepts}`"
        persistent-hint
        :suffix="extensao"
        :disabled="file == null"
        @change="emitChange"
      >
        <template #prepend>
          <v-btn icon @click="openInput"><v-icon>mdi-paperclip</v-icon></v-btn>
        </template>
        <template #append-outer v-if="exibirDelete">
          <v-btn icon color="error" @click="clearInput"
            ><v-icon small>fas fa-trash</v-icon></v-btn
          >
        </template>
        <template #progress>
          <v-progress-linear :value="progress"></v-progress-linear>
        </template>
      </v-text-field>
    </v-row>
  </v-col>
</template>
<script>
import Swal from "sweetalert2";
import axios from "axios";

import ApiService from "@/common/services/http/api.service";
const extensoesAccept = {
  1: ".pdf",
  2: ".png, .jpeg, .jpg, .bmp, .webp",
  3: ".xls, .xlsx",
  4: ".doc, .docx",
  5: ".zip, .rar",
  6: ".dwg, .dxf",
};
export default {
  props: {
    registro: {
      type: Object,
      default: () => ({}),
    },
    exibirDelete: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      nomeArquivo: "",
      extensao: "",
      file: null,
      containerSas: null,
      blob: null,
      config: {},
      loading: false,
      progress: 0,
    };
  },
  computed: {
    accepts() {
      if (!this.registro) return "";
      const aceitas = this.registro.extensoesID?.map((e) => extensoesAccept[e]);
      if (!aceitas) return ".png, .jpeg, .jpg, .bmp, .webp, .pdf";

      return aceitas.join(", ");
    },
  },
  async mounted() {
    const blobContainer = await this.getContainer();
    const urlContainer = blobContainer.split("|");
    this.config = {
      baseUrl: urlContainer[0],
      sasToken: urlContainer[1],
      blockSize: 2 * 1024 * 1024,
      complete: () => this.completeUpload(),
      progress: (data) => (this.progress = data),
    };
  },
  methods: {
    completeUpload() {
      this.loading = false;
      this.progress = 0;
      this.emitChange();
      this.$emit("upload", this.index, false);
    },
    async getContainer() {
      const cliente = JSON.parse(localStorage.getItem("cliente"));
      const containerSas = await ApiService.get(
        "Arquivo/sass-temp",
        `?clienteId=${cliente.id}&departamentId=${this.registro.departamentoID}`
      );
      this.containerSas = containerSas.data;
      return this.containerSas;
    },
    verificar(value) {
      value = value.toLowerCase();
      const aceitos = this.accepts.split(",");

      return aceitos.some((a) => value.includes(a.trim()));
    },
    openInput() {
      this.$refs.input.click();
    },
    setFile(event) {
      if (!this.verificar(event.target.value)) {
        Swal.fire({
          position: "center",
          title: "Tipo de arquivo não permitido",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }
      this.file = event.target.files[0];
      this.extensao = this.getExtensionFile(this.file);
      this.nomeArquivo = this.getNameFile(this.file, this.extensao);
      this.loading = true;
      this.$emit("upload", this.index, true);
      this.$azureUpload(
        {
          ...this.config,
          file: this.file,
        },
        axios.create({ headers: {} })
      );
    },
    getExtensionFile(file) {
      if (!file.name) return "";
      const aceitos = this.accepts.split(",");
      const nome = file.name.toLowerCase();
      return aceitos.find((a) => nome.includes(a.trim()))?.trim();
    },
    getNameFile(file, extension) {
      const nome = file.name.toLowerCase();
      const position = nome.indexOf(extension);
      return file.name.substr(0, position);
    },
    emitChange() {
      const nomeArquivo = `${this.nomeArquivo}${this.extensao}`;
      const arquivo = this.config.baseUrl;
      const index = this.index;
      this.$emit("change", { arquivo, nomeArquivo, index });
    },
    clearInput() {
      this.file = null;
      this.nomeArquivo = "";
      this.extensao = "";
      this.$emit("clearFile");
    },
  },
};
</script>
<style scoped>
.g-file-upload {
  gap: 1rem;
}
.g-input-upload {
  display: none;
}
</style>
